export default __webpack_public_path__ + "static/media/Gif_SterrenER.0b19453c.gif";